<template>
    <div class="download-store-right-tabs text-white pr-spc22">
        <ul class="download-store-right-tabs-nav nav nav-tabs flex items-center mb-10">
            <li class="nav-item">
                <a class="nav-link block text-size2 font-medium leading-6 opacity-50 px-spc38 pb-spc36"
                   href="#web-app"
                   @click.prevent="setActive('web-app')"
                   :class="{ active: isActive('web-app') }">
                    Web App
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link block text-size2 font-medium leading-6 opacity-50 px-spc38 pb-spc36"
                   href="#mobile-app"
                   @click.prevent="setActive('mobile-app')"
                   :class="{ active: isActive('mobile-app') }">
                    Mobile App
                </a>
            </li>
        </ul>
        <div class="download-store-right-tabs-body">
            <div class="download-store-tab-item hidden" :class="{ 'active': isActive('web-app') }" id="web-app">
                <div class="download-store-tab-item-inner">
                    <SectionHeading
                        title="Google Play & App Store"
                        content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd."
                    />
                    <div class="download-btns flex items-center flex-wrap mt-spc44 xl:mb-0 lg:mb-0 md:mb-spc9">
                        <a href="#" class="mr-spc1 block">
                            <img :src="playStore" alt="Play store">
                        </a>
                        <a href="#" class="block">
                            <img :src="appStore" alt="App store">
                        </a>
                    </div>
                </div>
            </div>
            <div class="download-store-tab-item hidden" :class="{ 'active': isActive('mobile-app') }" id="mobile-app">
                <div class="download-store-tab-item-inner">
                    <SectionHeading
                            title="App Store & Google Play"
                            content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd."
                    />
                    <div class="download-btns flex items-center flex-wrap mt-spc44 xl:mb-0 lg:mb-0 md:mb-spc9">
                        <a href="#" class="mr-spc1 block">
                            <img :src="playStore" alt="Play store">
                        </a>
                        <a href="#" class="block">
                            <img :src="appStore" alt="App store">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SectionHeading from "../../common/SectionHeading";
    export default {
        name: "DownloadStoreRight",
        components: {SectionHeading},
        data(){
            return {
                activeItem: 'web-app',
                playStore: require('@/assets/images/play-store.png'),
                appStore: require('@/assets/images/app-store.png'),
            }
        },
        methods: {
            isActive (menuItem) {
                return this.activeItem === menuItem
            },
            setActive (menuItem) {
                this.activeItem = menuItem
            }
        }
    }
</script>

<style scoped>

</style>